import React from "react";
import { useAuth } from "react-oidc-context";
import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
} from "@mui/material";
// Re-import NeuromuseLogo as a spacer reference
import { ReactComponent as NeuromuseLogo } from "../assets/img/logo/NeuroMuseLogo.svg";
function AuthPage() {
  const auth = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1c2526, #2e3b3e)",
        color: "white",
        textAlign: "center",
        px: 2,
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: "900px" }}>
        <Paper
          elevation={8}
          sx={{
            p: 6,
            borderRadius: 8, // Restored smooth edges with moderate rounding
            textAlign: "center",
            backgroundColor: "#ffffff",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
            maxWidth: "650px",
            mx: "auto",
            py: 7.25, // Maintained increased height by ~1cm
          }}
        >
          <Box mb={1} display="block" alignItems="center">
            {/* Placeholder for original SVG spacing */}
            <Box sx={{ height: "20px", mb: 0.5 }}>
              <NeuromuseLogo style={{ display: "none", height: "20px" }} />
            </Box>
            {/* Logo (NeuroMuse AI) - with Musical Notes */}
            <Box sx={{ position: "relative", display: "inline-block", mb: 0.5 }}>
              <Typography
                variant="h5"
                className="gradient-text font-header"
                sx={{ fontWeight: "bold", cursor: "pointer", fontSize: "2.5rem", margin: 0 }}
                onClick={() => {
                  // No navigation here, as this is the auth page
                }}
              >
                NeuroMuse AI
              </Typography>
              {/* Musical Notes */}
              <span className="musical-note note-1">♪</span>
              <span className="musical-note note-2">♫</span>
              <span className="musical-note note-3">♪</span>
            </Box>
            <Typography
              variant="h6"
              sx={{ mt: 1, color: "#666666", fontWeight: 500, lineHeight: 1.2, margin: 0 }} // Maintained 1cm gap
            >
              Building the Future of Music Generative AI
            </Typography>
          </Box>

          <Button
            variant="contained"
            sx={{
              mt: 3,
              px: 5,
              py: 1.5,
              fontWeight: "bold",
              fontSize: "1.1rem",
              textTransform: "none",
              backgroundColor: "black",
              color: "white",
              fontFamily: "'Raleway', sans-serif",
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
            onClick={() => auth.signinRedirect()}
          >
            Start 开始
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}

export default AuthPage;